import React from 'react';

import { FormViewer } from '@wix/form-viewer/widget';
import { FormQuizViewerProps } from './FormViewerQuizTypes';

const FormQuizViewer: React.FC<FormQuizViewerProps> = (props) => {
  return (
    <FormViewer
      i18n={props.i18n}
      bi={props.bi}
      ref={props.formViewerRef}
      formId={props.formId}
      onChange={props.onChange}
      onValidate={props.onValidate}
      values={props.values}
      errors={props.errors}
      externalData={props.externalData}
      panorama={props.panorama}
    />
  );
};

export default FormQuizViewer;
